import React, { useRef, useLayoutEffect } from 'react';
import classNames from 'classnames';

type PagesContentProps = {
    children;
    pageIndex: number;
    smooth?: boolean;
    isFullWidthChildren?: boolean;
};

const PagesContent: React.FC<PagesContentProps> = ({
    children,
    pageIndex = 0,
    smooth = false,
    ...rest
}) => {
    const pagesContentRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (pagesContentRef && pagesContentRef.current) {
            pagesContentRef.current.scrollTo({
                left: pageIndex * pagesContentRef.current.offsetWidth,
                behavior: 'smooth'
            });
        }
    }, [pageIndex]);

    const contentClasses = classNames({
        'awc-pages-content': true,
        'is-smooth': smooth,
        'is-full-width-children': Boolean(rest.isFullWidthChildren)
    });

    return (
        <div
            className={contentClasses}
            ref={pagesContentRef}
            {...rest}
        >
            {children}
        </div>
    );
};

export default PagesContent;
